import { render, staticRenderFns } from "./NetworkLobby.vue?vue&type=template&id=539e4c10&"
import script from "./NetworkLobby.vue?vue&type=script&lang=js&"
export * from "./NetworkLobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports